<template>
  <div id="app">
    <div id="header">
        <Navbar class=""></Navbar>
    </div>

    <div id="body">
      <div class="clearfix contentWrapper">
        <!--Clearfix is used to help align sidenav and main divs horizonatally next to-->
        <!--each other.-->

        <div class="sidenav">
          <!--The sidenav view is used on some pages for a vertical navigation menu.-->
          <!--For example unit- or flight-school-topic-navigation.-->
          <router-view name="sidenav"></router-view>
        </div>
        <div class="main">
          <!--The main view is where all the content appart from navigation menues goes.-->
          <router-view/>
        </div>

        <div>
          <router-view name="fullmain"></router-view>
        </div>

        <div class="center-content">
          <router-view name="centercontent"></router-view>
        </div>
        <div class="sidenav-right">
          <router-view name="rightsidenav"></router-view>
        </div>
      </div>
    </div>
    <div id="footer">
      <div style="font-family: 'Remingtoned Type'" class="text-align-center padding-10">
        <p>Pilot and Mission Database v.2 by Thaine</p>
        <p>Please report bugs <a style="color: #e7e6e4" href="https://gitlab.com/flying-tin-cans/pam-v2-ftc/-/issues" >here</a>.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import Logger from './components/Logger'

export default {
  name: 'App',
  components: {
    Navbar,
    Logger,
  },
  mounted() {
    this.$auth.syncSession(this.$options.name);
  }
}
</script>

<style>
#app {
  min-height: 100%;
  position: relative;

  font-family: Roboto, Arial, sans-serif, Remingtoned Type, Dawning of a New Day, Another Typewriter, Tannenberg, KurrentKupferstichThin;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

#header {
  /*height: 50px;*/
  width: 100%;
  /*border-style: solid;*/
  /*border-width: 1px;*/
  /*border-radius: 15px;*/
  /*border-color: rgba(0, 0, 0, 0.4);*/
  /*background: #3a3a3c;*/
}

.remington-typed-font {
  font-family: "Remingtoned Type";
  color: #1b1b1b;
}

#body {
  height:100%;
  /*padding: 10px;*/
  padding-bottom: 35px; /* Height of footer */
  /*overflow: scroll;*/
}

#footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 35px;
  /*border-style: solid;*/
  /*border-width: 1px;*/
  /*border-radius: 15px;*/
  /*border-color: rgba(0, 0, 0, 0.4);*/
  /*background: #3a3a3c;*/
  /*opacity: 80%;*/
}

@font-face {
  font-family: "Remingtoned Type";
  src: url("/assets/fonts/TypewriterFont.ttf");
  /*src: local("Remingtoned Type");*/
}

@font-face {
  font-family: "Dawning of a New Day";
  src: url("/assets/fonts/DawningofaNewDay.ttf");
  /*src: local("Dawning of a New Day");*/

}

@font-face {
  font-family: "TrueTypewriter PolygLOTT";
  src: url("/assets/fonts/TTWPGOTT.ttf");
  /*src: local("TrueTypewriter PolygLOTT");*/

}

@font-face {
  font-family: "Deutschische";
  src: url("/assets/fonts/Deutschische.otf");
  /*src: local("Deutschische");*/

}

@font-face {
  font-family: "DSWallau";
  src: url("/assets/fonts/DSWallau.ttf");
  /*src: local("DSWallau");*/

}

@font-face {
  font-family: "Another Typewriter";
  src: url("/assets/fonts/atwriter.ttf");
  /*src: local("atwriter");*/

}

@font-face {
  font-family: "KurrentKupferstichThin";
  src: url("/assets/fonts/KurrentKupferstichThin.ttf");
  /*src: local("KurrentKupferstichThin");*/

}

@font-face {
  font-family: "Tannenberg";
  src: url("/assets/fonts/Tannenberg-Bold.ttf");
  /*src: local("Tannenberg-Bold");*/

}

@font-face {
  font-family: "Old Stamper";
  src: url("/assets/fonts/old_stamper.ttf");
  /*src: local("Tannenberg-Bold");*/

}

/*div{*/
  /*border: 1px solid yellow;*/
/*}*/

html {
  /*height: 100%;*/
  background:url("./assets/images/background.jpg");
  background-color: #c7c7c7;
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

}

body {
  min-width: 1020px;
  color: #ffffff;

}

.contentWrapper {
  width: calc(100% - 20px);
  /*height: 100%;*/
  /*min-height: 800px;*/
  padding: 10px;
  /*border-style: solid;*/
  /*border-width: 1px;*/
  /*border-radius: 15px;*/
  /*border-color: rgba(0, 0, 0, 0.4);*/
  /*background: rgba(0, 0, 0, 0.5);*/
}

.fixed {
  position: fixed;
}

h1, h2{
  color: #F28900;
  padding: 2px 0px;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))
}

h3{
  color: #F28900;
  padding: 2px 0px;
  /*background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))*/
}

h4{
  color: #F28900;
  margin: 4px;
  /*padding: 2px 0px;*/
  /*background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))*/
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  clear: both;
}

a {
  padding-right: 5px;
}

table {
  border-collapse: collapse;
}

tr,td {
  margin: 0;
  padding: 0px 5px 0px 5px;
  /*border: 1px solid green;*/
}

th {
  padding: 0px 5px;
}

button {

  text-align: center;
  padding: 5px;
  border-style: solid;
  border-width: 1px;
  border-radius: 10px;
  border-color: rgba(0, 0, 0, 0.4);
  background-color: rgb(255, 255, 255);
}

button:hover {

  text-align: center;
  padding: 5px;
  border-style: solid;
  border-width: 1px;
  border-radius: 10px;
  color: rgb(255, 255, 255);
  border-color: #F28900;
  background-color: rgb(95, 95, 95);
}

input, textarea {

  border:none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 5px;
  padding: 5px;
  color: #1b1b1b;
  max-width: 99%;
}

textarea {
  width: 75%;
}

select {

  border: none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 2px;
  font-size: large;
  padding: 2px;
  margin: 2px;
  color: #1b1b1b;
}

/*vSELECT specific styles*/
.v-select .vs__dropdown-toggle{
  border: none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 2px;
  /*font-size: large;*/
  padding: 2px;
  margin: 2px;
  color: #1b1b1b;
}

.v-select .vs__dropdown-menu {
  /*color: #1b1b1b;*/
  /*background: rgb(95, 95, 95);*/
  font-size: large;

  /*border-color: #646464;*/
}

.v-select .vs_dropdown-option{
  background: #F28900;
}

.v-select .vs__dropdown-option--highlight{
  background-color: #F28900;
}


.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

.sidenav {
  float: left;
  /*min_width: calc(20% - 7px);*/
  /*width: calc(20% - 7px); !* Whished widht in % minus 2x border size *!*/
  min_width: calc(20% - 7px);
  width: calc(20% - 7px); /* Whished widht in % minus 2x border size */
  padding-right: 5px;
  /*border: 1px blue solid;*/
  /*background-color: red;*/
}

.sidenav a{
  display: block;
}

.main {
  float: left;
  width: calc(80% - 7px); /* Whished widht in % minus 2x border size */
  padding-left: 5px;
}

.center-content {
  float:left;
  width: calc(60% + 4px);
  /*background-color: white;*/
}

.sidenav-right {
  float: right;
  min_width: calc(20% - 7px);
  width: calc(20% - 7px); /* Whished widht in % minus 2x border size */
  padding-left: 5px;
  /*background-color: green;*/
}

.container {
  margin: 10px 2px 10px 2px;
  padding: 10px;
  border-style: solid;
  border-width: 0px;
  border-radius: 15px;
  border-color: rgba(0, 0, 0, 0.0);
  background: rgba(0, 0, 0, 0.1);
}

.container-transparent {
  margin: 10px 2px 10px 2px;
  padding: 10px;
}

.split-div{
  width: calc(50% - 24px);
}

.side-nav-heading {

  color: #F28900;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))

}

.div-button{

  width: calc(100% - 26px);
  margin: 10px 2px 10px 2px;
  padding: 10px;
  cursor: pointer;
  border-style: solid;
  border-width: 1px;
  border-radius: 15px;
  border-color: rgba(0, 0, 0, 0.0);
  background: rgba(0, 0, 0, 0.1);
}

.div-button a {
  text-decoration: none;
  color: inherit;
  outline: 0;
  padding: 0px;
}

.div-button:hover {
  border-style: solid;
  border-width: 1px;
  border-radius: 15px;
  border-color: #F28900;
  background: rgba(255, 255, 255, 0.7);
}

.div-button-inactive{

  width: calc(100% - 26px);
  margin: 10px 2px 10px 2px;
  padding: 10px;
  /*cursor: pointer;*/
  border-style: solid;
  border-width: 1px;
  border-radius: 15px;
  border-color: rgba(0, 0, 0, 0.0);
  background: rgba(0, 0, 0, 0.1);
}

.typed-on-paper .div-button{

  margin: 0;
  padding: 0px 5px 0px 5px;
  cursor: pointer;
  border-style: none;
  border-width: 1px;
  border-radius: 2px;
  border-color: #646464;
  background: rgba(0, 0, 0, 0);
  color: #1b1b1b;
}

.typed-on-paper-a4 .div-button{

  margin: 0;
  padding: 0px 5px 0px 5px;
  cursor: pointer;
  border-style: none;
  border-width: 1px;
  border-radius: 2px;
  border-color: #646464;
  background: rgba(0, 0, 0, 0);
  color: #1b1b1b;
  padding-bottom: 5px;
}

.typed-on-paper .div-button:hover {
  margin: 0;
  padding: 0px 5px 0px 5px;
  border-width: 1px;
  border-radius: 2px;
  border-color: transparent;
  background: rgba(255, 255, 255, 0.5);

}

.typed-on-paper-a4 .div-button:hover {
  margin: 0;
  padding: 0px 5px 0px 5px;
  border-width: 1px;
  border-radius: 15px;
  border-color: transparent;
  background: rgba(255, 255, 255, 0.5);
  padding-bottom: 5px;
}

.div-button-inactive{

  width: calc(100% - 26px);
  margin: 10px 2px 10px 2px;
  padding: 10px;
  /*cursor: pointer;*/
  border-style: solid;
  border-width: 1px;
  border-radius: 15px;
  border-color: rgba(0, 0, 0, 0.0);
  background: rgba(0, 0, 0, 0.1);
}

/*General quick style aspects*/

.full-height{
  height: 100%;
}

.height-100px{
  height: 100px;
}

.full-width{
  width: 100%;
}

.half-width{
  width: calc(50% - 2px);
}

.width-90{
  width: 90%;
}

.width-80{
  width: 80%;
}

.width-70{
  width: 70%;
}

.width-60{
  width: 60%;
}

.width-40{
  width: 40%;
}

.width-30{
  width: 30%;
}

.width-20{
  width: 20%;
}

.width-10{
  width: 10%;
}

.width-5{
  width: 5%;
}

.width-auto{
  width: auto;
}

.padding-0-10{
  padding: 0px 10px;
}

.padding-10{
  padding: 10px;
}

.padding-2-10 {
  padding: 2px 10px;
}

.padding-10-0 {
  padding: 10px 0px;
}

.margin-auto{
  margin: auto;
}

.text-align-left{
  text-align: left;
}

.text-align-center{
  text-align: center;
}

.text-align-right{
  text-align: right;
}

.text-align-justify{
  text-align: justify;
}

.vertical-align-middle{
  vertical-align: middle;
}

.inline-block{
  display: inline-block;
}

/*.inline{*/
  /*display: inline*/
/*}*/

.table {
  display: table;
}

.table-cell {
  display: table-cell;
}


.float-left{
  float: left;
}

.float-right{
  float: right;
}

.heading{
  font-weight: bold;
  font-size: 1.2em;
}

.white-space-pre-line{
  white-space: pre-line;
}

/*Style for typewriter on paper look*/

.typed-on-paper {
  /*background: #e9e9e7;*/
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  background-image: url("./assets/images/ftcpaper.png");
  border-radius: 2px;
  padding: 30px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
  box-shadow: 10px 10px 10px rgba(10,10,10,0.5);
}

.typed-on-paper-a4 {
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px, #ebeae8 1px, #e6e1e0 1px);*/
  /*background: #e9e9e7;*/
  background-image: url("./assets/images/ftcpaper.png");
  background-size: cover;
  /*background-position: center;*/
  border-radius: 2px;
  /*padding: 120px;*/
  padding-left: 120px;
  padding-right: 120px;
  padding-bottom: 50px;
  padding-top: 50px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
  /*font-size: large;*/
  box-shadow: 10px 10px 10px rgba(10,10,10,0.5);
  min-width: 21cm;
  max-width: 21cm;
  /*max-height: 29.7cm;*/
  min-height: 29.7cm;
  margin-left: 50px;
}

.typed-on-paper-a4-strict {
  /*background: #ecd7b0;*/
  background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);
  /*background-image: url("/frontend/src/assets/images/webpage_images/paper-background.png");*/
  /*background-size: cover;*/
  /*background-position: center;*/
  border-radius: 2px;
  padding: 30px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
  /*font-size: medium;*/
  box-shadow: 10px 10px 10px rgba(10,10,10,0.5);
  min-width: 21cm;
  max-width: 28cm;
}

.typed-on-paper-tabs {
  border-radius: 15px;
  background-image: url("./assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  font-family: "Remingtoned Type";
  box-shadow: 10px 10px 10px rgba(10,10,10,0.5);
  color: #1b1b1b;
  /*padding: 25px;*/
  padding-top: 30px;
  padding-bottom: 30px;
  margin-left: 8em;
}

.typed-on-paper-tabs-2nd {
  border-radius: 15px;
  background-image: url("./assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  font-family: "Remingtoned Type";
  box-shadow: 10px 10px 10px rgba(10,10,10,0.5);
  color: #1b1b1b;
  /*padding: 25px;*/
  padding-top: 30px;
  padding-bottom: 30px;
  margin-left: 14em;
}

.typed-on-paper-tabs-list {
  border-radius: 15px;
  background-image: url("./assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  font-family: "Remingtoned Type";
  box-shadow: 10px 10px 10px rgba(10,10,10,0.5);
  color: #1b1b1b;
  /*padding: 25px;*/
  /*padding-top: 30px;*/
  /*padding-bottom: 30px;*/
}

.typed-on-paper-link:hover {
  background: rgba(255, 255, 255, 0.5);
  border-color: transparent;
}

.typed-on-paper-a4-link:hover {
  background: rgba(255, 255, 255, 0.5);
  border-color: transparent;
}

.typed-on-paper-a4-link-strict:hover {
  background: rgba(255, 255, 255, 0.5);
  border-color: transparent;
}

.typed-on-paper-tabs-link:hover {
  background: rgba(255, 255, 255, 0.5);
  border-color: transparent;
}

.bigSignature {
  font-size: xx-large;
  opacity: 0.8;
  color: #000F55;
  font-weight: bold;
  font-family: "Dawning of a New Day";
}


.polyglottTypewriter {
  text-decoration: black;
  font-size: larger;
  font-family: "TrueTypewriter PolyglOTT";
}


.Deutschische {
  text-decoration: black;
  font-family: "Deutschische";
}

.dsWallau {
  text-decoration: black;
  font-family: "DSWallau";
}

.typed-on-paper button {

  background: rgba(0, 0, 0, 0);
  border-color: #646464;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-a4 button {

  background: rgba(0, 0, 0, 0);
  border-color: #646464;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-a4-strict button {

  background: rgba(0, 0, 0, 0);
  border-color: #646464;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-tabs button {
  background: rgba(0, 0, 0, 0);
  border-color: #646464;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-tabs-padding {
  padding-top: 5em;
  margin-left: 4em;
}

.typed-on-paper button:hover {
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-a4 button:hover {

  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-a4-strict button:hover {

  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-tabs button:hover {
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper textarea,
.typed-on-paper input {

  border:none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 5px;
  font-size: large;
  padding: 5px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-a4 textarea,
.typed-on-paper-a4 input {

  border:none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 5px;
  font-size: large;
  padding: 5px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-a4-strict textarea,
.typed-on-paper-a4-strict input {

  border:none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 5px;
  font-size: large;
  padding: 5px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-tabs textarea,
.typed-on-paper-tabs input {
  border:none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 5px;
  font-size: large;
  padding: 5px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper select {

  border: none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 2px;
  padding: 2px;
  margin: 2px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-a4 select {

  border: none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 2px;
  padding: 2px;
  margin: 2px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-a4-strict select {

  border: none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 2px;
  padding: 2px;
  margin: 2px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper-tabs select {
  border: none;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 2px;
  padding: 2px;
  margin: 2px;
  color: #1b1b1b;
  font-family: "Remingtoned Type";
}

.typed-on-paper h1 {
  font-size: inherit;
  font-weight: bolder;
  color: inherit;
  background-image: none;
}

.typed-on-paper-a4 h1 {
  font-size: larger;
  font-weight: bolder;
  color: inherit;
  background-image: none;
}

.typed-on-paper-a4-strict h1 {
  font-size: larger;
  font-weight: bolder;
  color: inherit;
  background-image: none;
}

.typed-on-paper-tabs h1 {
  font-size: inherit;
  font-weight: bolder;
  color: inherit;
  background-image: none;
}

.typed-on-paper h2 {
  font-size: inherit;
  font-weight: bolder;
  color: inherit;
  background-image: none;
}

.typed-on-paper-a4 h2 {
  font-size: inherit;
  font-weight: bolder;
  color: inherit;
  background-image: none;
}

.typed-on-paper-a4-strict h2 {
  font-size: inherit;
  font-weight: bolder;
  color: inherit;
  background-image: none;
}

.typed-on-paper-tabs h2 {
  font-size: inherit;
  font-weight: bolder;
  color: inherit;
  background-image: none;
}

.typed-on-paper th {
  font-weight: normal;
}

.typed-on-paper-a4 th {
  font-weight: normal;
}

.typed-on-paper-a4-strict th {
  font-weight: normal;
}

.typed-on-paper-tabs th {
  font-weight: normal;
}

.typed-on-paper hr {
  border: 1px solid black;
}

.typed-on-paper-a4 hr {
  border: 1px solid black;
}

.typed-on-paper-a4-strict hr {
  border: 1px solid black;
}

.typed-on-paper-tabs hr {
  border: 1px solid black;
}

.typed-on-paper ul {
  list-style-type: circle;
}

.typed-on-paper-a4 ul {
  list-style-type: circle;
}

.typed-on-paper-a4-strict ul {
  list-style-type: circle;
}

.typed-on-paper-tabs ul {
  list-style-type: circle;
}

.axis {
  background-color: rgba(0,0,102,0.25);
  padding: 4px;
  border-radius: 15px;
}

.allied {
  background-color: rgba(153,0,0,0.25);
  padding: 4px;
  border-radius: 15px;
}

.luftwaffe {
   background-color: rgba(0,0,102,0.25);
   border-radius: 15px;
 }

.ra {
  background-color: rgba(0, 94, 202, 0.25);
  border-radius: 15px;
}

.vvs {
  background-color: rgba(100,0,0,0.25);
  border-radius: 15px;
}

.raf {
  background-color: rgba(200, 0, 0, 0.25);
  border-radius: 15px;
}

.usaaf {
  background-color: rgba(77, 200, 0, 0.25);
  border-radius: 15px;
}

.farr {
   background-color: rgba(102, 100, 0, 0.25);
   border-radius: 15px;
 }

.roster-image {

  width: 425px;
  height: 163px;
}

/*CSS FOR draggable-nested-tree*/

DraggableTree div {
  border: none;
}

.he-tree .tree-node {

  margin-bottom: 10px;
}


.he-tree{
  /*border: 1px solid #ccc;*/
  padding: 20px;
}

.tree-node{
}

.tree-node {
  border: none
}

.tree-node-children{
  border: none
}

.tree-node-inner{
  /*padding: 5px;*/
  /*border: 1px solid #ccc;*/
  cursor: pointer;
}

.tree-node-inner div {
  /*border: 1px solid red*/
}

.tree-node-inner-back{
  border: none
}
.draggable-placeholder{
}
.draggable-placeholder-inner{
  /*border: 1px dashed #0088F8;*/
  box-sizing: border-box;
  background: rgba(0, 136, 249, 0.09);
  /*color: #0088f9;*/
  text-align: center;
  padding: 0;
  display: flex;
  align-items: center;
}

.fa {
  padding: 5px;
  font-size: 20px;
  width: 20px;
  text-align: center;
  text-decoration: none;
  margin: 0px 0px;
  border-radius: 50%;
}

.fa:hover {
  opacity: 0.7;
}

.fa-facebook {
  background: #3B5998;
  color: white;
}

.fa-youtube {
  background: #bb0000;
  color: white;
}

.unit-buttons{
  color: #F28900;
  font-size: 1em;
  margin: 2px 0px 0px 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  width: calc(100% - 20px - 26px);
}

.member-buttons{
  font-size: 1em;
  margin: 2px 0px 0px 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  width: calc(100% - 20px - 26px);
}


</style>



// WEBPACK FOOTER //
// src/App.vue